
	import NavBar from "@/components/NavBar.vue";
	import ProgressIndicator from "@/components/ProgressIndicator.vue";
	import { defineComponent, onMounted, reactive, ref } from "vue";
	import { Patient } from "@/domain/entities/Patient";
	import { DateTime } from "luxon";
	import useUser from "@/store/UserState";

	import { orderBy, debounce } from "lodash";
	import { pprint } from "@/helpers/pprint";
	import { onBeforeRouteLeave } from "vue-router";

	function formatDiaryDate(date: string) {
		return DateTime.fromFormat(date, 'dd/MM/y').toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' })
	}
	function toggleQuestionForm(ev: Event) {
		((ev.currentTarget as HTMLElement)
			.nextElementSibling as HTMLElement).classList.toggle("active");
	}

	export default defineComponent({
		name: "Measurements",

		components: {
			ProgressIndicator,
			NavBar,
		},

		setup() {
			const {
				user: patient,
				fetchDiaryQuestions,
				updateDiary,
				MaxDiaryDays,
			} = useUser();
			const onFinishTyping = debounce((e) => {
				pprint(e);
				updateDiary();
			}, 1000);

			let editableTable: any = reactive({});
			let intervalCheckCurrentTime: any;
			let today = DateTime.local();

			const checkDiaryIsEditable = () => {
				for (let date in (patient.value as Patient).diaries!) {
					const diaryDate = DateTime.fromFormat(date, 'dd/MM/y');
					editableTable[date] = diaryDate.hasSame(today, 'day');
				}
			};
			let sortedDates = ref<string[]>([]);
			onMounted(async () => {
				await fetchDiaryQuestions();
				// date - bool
				sortedDates.value = orderBy(
					Object.keys((patient.value as Patient).diaries!),
					(o: any) => {
						const d = DateTime.fromFormat(o, 'dd/MM/y')
						return d.toMillis();
					},
					["desc"]
				).slice(0, MaxDiaryDays);
				checkDiaryIsEditable();
				intervalCheckCurrentTime = setInterval(() => {
					checkDiaryIsEditable();
				}, 5000);
			});
			onBeforeRouteLeave(() => {
				clearInterval(intervalCheckCurrentTime);
			});

			return {
				patient,
				formatDiaryDate,
				toggleQuestionForm,
				onFinishTyping,
				editableTable,
				sortedDates,
			};
		},
	});
